export const GET_ALL_PRODUCTS_REQUESTED = 'views/Home/GET_ALL_PRODUCTS_REQUESTED';
export const GET_ALL_PRODUCTS_SUCCESS = 'views/Home/GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_FAILED = 'views/Home/GET_ALL_PRODUCTS_FAILED';
